import { createFileRoute } from '@tanstack/react-router'
import React from 'react'
import { SiteAssistant } from '../site/components/site-assistant'

// The settings open on the assistant: what people come to change most.
export const Route = createFileRoute('/_auth/_main/websites/$siteId/settings/')({
    component: Assistant,
})

function Assistant() {
    const { siteId } = Route.useParams()

    return <SiteAssistant siteId={siteId} />
}
